import tileImg from '../assets/images/Tile.jpg';
import tileImg1 from '../assets/images/Tile1.jpg';
import tileImg3 from '../assets/images/Tile3.jpg';
import tileImg4 from '../assets/images/Tile4.jpg';
import tileImg5 from '../assets/images/Tile5.jpg';
import tileImg6 from '../assets/images/Tile6.jpg';
import tileImg7 from '../assets/images/Tile7.jpg';
import tileImg8 from '../assets/images/Tile8.jpg';
import tileImg9 from '../assets/images/Tile9.jpg';

const tileData = [
  { name: 'abc1', src: tileImg1 },
  { name: 'abc2', src: tileImg },
  // { name: 'abc3', src: tileImg2 },
  { name: 'abc4', src: tileImg3 },
  { name: 'abc5', src: tileImg4 },
  { name: 'abc6', src: tileImg6 },
  { name: 'abc7', src: tileImg5 },
  { name: 'abc8', src: tileImg7 },
  { name: 'abc9', src: tileImg8 },
  { name: 'abc10', src: tileImg9 },
  // { name: 'abc11', src: tileImg },
  // { name: 'abc12', src: tileImg },
  // { name: 'abc13', src: tileImg },
  // { name: 'abc14', src: tileImg },
  // { name: 'abc15', src: tileImg },
];

export default tileData;
